<template>
  <div :style="style" class="preview-text-field">
    <PreviewTypographyLegacy :text="placeholder" color="placeholder" />
    <span class="preview-dropdown__icon">
      <PhCaretDown size="16" />
    </span>
  </div>
</template>

<script>
import { PhCaretDown } from '@phosphor-icons/vue'
import PreviewTypographyLegacy from './legacy/PreviewTypographyLegacy.vue'

import { useMergedTheme } from './mixins/useMergedTheme'

export default {
  name: 'PreviewDropDown',
  components: { PhCaretDown, PreviewTypographyLegacy },
  mixins: [useMergedTheme],
  props: {
    placeholder: { type: String, default: '' },
  },
  computed: {
    style() {
      const { mergedTheme } = this

      return {
        backgroundColor: mergedTheme.colors.background.primary,
        borderColor: mergedTheme.colors.background.divider,
        borderRadius: `${mergedTheme.borderRadius.control}rem`,
        color: mergedTheme.colors.text.placeholder,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.preview-text-field {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
  overflow: hidden;
  border-style: solid;
  border-width: 1px;
  margin-bottom: 8px;
}

.preview-dropdown__icon {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 8px;
  color: var(--color-text-tertiary);
}
</style>
